var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.117,
    height: 14.117,
    viewBox: "0 0 14.117 14.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_24_icon_container",
    "data-name": "24 icon container",
    width: 14.117,
    height: 14.117,
    fill: "currentColor",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_insert_2400061_000000",
    d: "M18.6,20.648h2.737V9.7H18.6Zm-4.105,0h2.737V9.7H14.49ZM11.754,8.332H10.385v3.421H8.332l2.737,2.736,2.737-2.736H11.754Zm-2.053,13h2.736V15.174H9.7Z",
    transform: "translate(-7.774 -7.773)",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnToggle);
export default __webpack_public_path__ + "static/media/ColumnToggle.c4894d15.svg";
export { ForwardRef as ReactComponent };